import { withProcedureWraper } from "../../../../..";
import { Error, Loading } from "../../../../../../../components";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateApplicationForSuspendContractForm } from "../../../../absence-letter/components/create-application-for-suspend-contract";
import { useAFLRequest } from "../../../../absence-letter/hooks";
export const SuspendContrastTSNEdit = withProcedureWraper(() => {
  const { data = {}, isLoading: isRequestLoading, isFetching: isRequestFetching, isError } = useAFLRequest();

  if (isRequestLoading) return <Loading />;
  if (isError) return <Error description="Không tìm thấy dữ liệu" />;
  return (
    <ProcedureLayout title="Chỉnh sửa đơn xin tạm hoãn HĐLĐ" loading={isRequestFetching}>
      <CreateApplicationForSuspendContractForm data={data} />
    </ProcedureLayout>
  );
});
